import React, { Component } from 'react';
import SlidePanel from '../shared/SlidePanel';
import MergeClientsView from './MergeClientsView';

/**
 * Standalone merge sidebar for the client-list multi-select flow (and the
 * edit-client merge suggestion).
 *
 * The list hands us two userIds; which one SURVIVES is chosen inline in the
 * view (the two record cards), so the panel is just the slide-panel chrome.
 *
 * Spec: docs/client-flows.md §7.2
 */
class MergeClientsPanel extends Component {
    constructor(props) {
        super(props);
        this.slidePanelRef = React.createRef();
    }

    close = () => {
        if (this.slidePanelRef.current) this.slidePanelRef.current.handleClose();
        else this.props.onClose();
    };

    render() {
        return (
            <SlidePanel ref={this.slidePanelRef} width={760} onClose={this.props.onClose} className="cdp-panel">
                <div className="cdp-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
                        <button className="beu-icon-btn" onClick={this.close} title="Back to clients">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="15 18 9 12 15 6" />
                            </svg>
                        </button>
                        <h2 className="cdp-header-name">Merge clients</h2>
                    </div>
                </div>
                <div className="cdp-body" style={{ padding: 0, display: 'flex', flexDirection: 'column' }}>
                    <MergeClientsView
                        winnerUserId={this.props.initialWinnerUserId}
                        loserUserId={this.props.initialLoserUserId}
                        onBack={this.close}
                        onConfirmed={(data) => { if (this.props.onConfirmed) this.props.onConfirmed(data); }}
                    />
                </div>
            </SlidePanel>
        );
    }
}

export default MergeClientsPanel;
